import { Col, Row } from 'antd';
import React, { useEffect } from 'react'
import { translate } from 'react-i18next';
import { useSelector } from 'react-redux';

const IframChat = ({ t, isConnect }) => {
    const roomID = useSelector(state => state.lobby.lobbyRoomID)

    useEffect(() => {
        const contentHeight = () => {
            const IframChat = document.getElementsByClassName('IframChat')[0]
            const nav = document.getElementsByClassName('participant-header')[0]
            const antAlertMessage = document.getElementsByClassName('ant-alert-message')[0]
            const title = document.getElementsByClassName('participant-chat-title')[0]
            const participantBody = document.getElementsByClassName('participant-chat-body')[0]
            if (IframChat) {
                const antAlertMessageHeight = antAlertMessage ? antAlertMessage?.offsetHeight + 20 : 0
                const chatHeight = `${(window.innerHeight - (nav.offsetHeight) - antAlertMessageHeight) - title?.offsetHeight}px`
                const heightChat = `${window.innerHeight - 105}px`
                if (window.innerWidth < 1024) {
                    participantBody.style.height = heightChat
                    IframChat.style.height = heightChat
                } else {
                    participantBody.style.height = chatHeight
                    IframChat.style.height = chatHeight
                }
            }

        }
        contentHeight()
        // window.addEventListener('resize', contentHeight);
    }, [])

    /**
     * mock show chat
     */
    useEffect(() => {
        const participantChat = document.getElementsByClassName('participant-chat')[0]
        if (participantChat && isConnect) {
            if (window.innerWidth < 1024) {
                participantChat.style.width = '100%'
            } else {
                participantChat.style.width = '400px'
            }
        }
    }, [isConnect, roomID])

    return (
        <>
            <Row>
                <Col span={24}>
                    <div className="participant-chat">
                        <div className="participant-chat-title">
                            {t('lobby_participant.moderator')}
                        </div>
                        <div
                            className="participant-chat-body"
                            dangerouslySetInnerHTML={{
                                __html: `<iframe 
                            class="IframChat"
                            src="${window._env_.rocketChatIFrameUrl}group/${roomID}?layout=embedded" 
                            width="400px"
                            height="100px"
                            >
                        </iframe>`
                            }}
                        />
                    </div>
                </Col>
            </Row>
        </>
    )
}

export default translate()(IframChat)
